/**
 * Labstep
 *
 * @module components/NotificationAlert/Action/Create
 * @desc Action to create (or restore) notification alert
 */

import EntityActionCreate from 'labstep-web/components/Entity/Action/Create';
import { EntityActionUpdateContainer as EntityActionUpdate } from 'labstep-web/components/Entity/Action/Update';
import type { ActionComponentProps } from 'labstep-web/core/Action/Component/types';
import { NotificationAlert } from 'labstep-web/models/notification-alert.model';
import type React from 'react';
import type { NotificationAlertActionCreateProps } from './types';

export const DEFAULT_ACTION_COMPONENT_PROPS: ActionComponentProps = {
  type: 'icon',
  elementProps: {
    name: 'bell',
    popup: { content: 'Set Alert' },
  },
};

export const NotificationAlertActionCreate: React.FC<
  NotificationAlertActionCreateProps
> = ({ metadata, createOptions }) => {
  if (metadata.notification_alert) {
    return (
      <EntityActionUpdate
        entityName={metadata.notification_alert.entityName}
        id={metadata.notification_alert.guid}
        body={{ deleted_at: null }}
        actionComponentProps={DEFAULT_ACTION_COMPONENT_PROPS}
      />
    );
  }

  return (
    <EntityActionCreate
      parentName={metadata.entityName}
      parentId={metadata.guid}
      overwriteCanCreateProps={{
        parentName: metadata.entityName,
        parentId: metadata.id,
      }}
      entityName={NotificationAlert.entityName}
      actionComponentProps={DEFAULT_ACTION_COMPONENT_PROPS}
      options={createOptions}
    />
  );
};
